import { Pipe, PipeTransform } from '@angular/core';
import { Settings } from '../settings.class';
import { Workarea } from '../workarea.class';

@Pipe({
    name: 'workareaMarker',
    standalone: false,
})
export class WorkareaMarkerPipe implements PipeTransform {
    transform<T>(workarea: Workarea, filteredWorkareas: any[]) {
        return {
            url: `data:image/svg+xml;utf-8,${encodeURIComponent(
                Settings.getMarker(
                    workarea.id,
                    workarea.number,
                    workarea.status_colorcode,
                    filteredWorkareas?.length < 300 || Settings.mapSettings['largeMapTextShadow'],
                    workarea.has_documents,
                    workarea.type,
                    workarea?.extra?.execution === 'Nacht'
                )
            )}`,
            anchor: new google.maps.Point(15, 29),
        };
    }
}
